export default __webpack_public_path__ + "static/media/image26.bac728e0.jpg";